// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2135":"b421bca3","2869":"a8abbf1d","4028":"b421bca3","5063":"a8abbf1d","8622":"b421bca3"}[chunkId] + ".chunk.css";
};